import React from "react";
import { withTranslation } from "react-i18next";
import TIMELINE_RULE_LENS from "../constants/timelineRuleLens";

const RuleLensTabs = ({ t, ruleCode, onRuleCodeChange }) => (
  <div className="mat-rule-lens" role="tablist" aria-label={t("MetricAnomalyTimeline.ruleLens.label")}>
    {TIMELINE_RULE_LENS.map((rule) => {
      const active = ruleCode === rule.value;
      return (
        <button
          key={rule.value || "all"}
          type="button"
          role="tab"
          aria-selected={active}
          className={`mat-rule-pill${active ? " mat-rule-pill--active" : ""}`}
          onClick={() => onRuleCodeChange(rule.value)}
        >
          {t(rule.labelKey)}
        </button>
      );
    })}
  </div>
);

export default withTranslation()(RuleLensTabs);
